// constants
import { LetterHeadActionTypes } from './constants';
import { LetterHead as LetterHeadDataType } from 'src/types/letterHead';

export type LetterHeadActionType = {
    type:
        | LetterHeadActionTypes.API_RESPONSE_SUCCESS
        | LetterHeadActionTypes.API_RESPONSE_ERROR
        | LetterHeadActionTypes.GET_LETTER_HEAD
        | LetterHeadActionTypes.ADD_LETTER_HEAD
        | LetterHeadActionTypes.EDIT_LETTER_HEAD
        | LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD
        | LetterHeadActionTypes.GET_LETTER_HEADS
        | LetterHeadActionTypes.RESET
        | LetterHeadActionTypes.RESET_SUCCESS
        | LetterHeadActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const letterHeadApiResponseSuccess = (
    actionType: string,
    data: LetterHeadDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LetterHeadActionType => ({
    type: LetterHeadActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const letterHeadApiResponseError = (
    actionType: string,
    data: LetterHeadDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LetterHeadActionType => ({
    type: LetterHeadActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addLetterHead = (params: any): LetterHeadActionType => ({
    type: LetterHeadActionTypes.ADD_LETTER_HEAD,
    payload: params,
});

export const editLetterHead = (params: any): LetterHeadActionType => ({
    type: LetterHeadActionTypes.EDIT_LETTER_HEAD,
    payload: params,
});

export const getLetterHead = (params: any): LetterHeadActionType => ({
    type: LetterHeadActionTypes.GET_LETTER_HEAD,
    payload: params,
});

export const getSelectedLetterHead = (params: any): LetterHeadActionType => ({
    type: LetterHeadActionTypes.GET_SELECTED_LETTER_HEAD,
    payload: params,
});

export const getLetterHeads = (params: any): LetterHeadActionType => ({
    type: LetterHeadActionTypes.GET_LETTER_HEADS,
    payload: params,
});

export const resetLetterHead = (): LetterHeadActionType => ({
    type: LetterHeadActionTypes.RESET,
    payload: {},
});

export const resetLetterHeadSuccess = (): LetterHeadActionType => ({
    type: LetterHeadActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetLetterHeadError = (): LetterHeadActionType => ({
    type: LetterHeadActionTypes.RESET_ERROR,
    payload: {},
});
